// @flow
import styled from 'styled-components';

export const Container = styled.div`
    background-color: ${p => p.theme.productBorderColor};
    border-radius: 0.4rem;
    padding: 0.5rem;
    text-align: center;
`;

export const TimerBox = styled.span`
    display: block;
    font-size: 1.5rem;
    margin-bottom: -0.25rem;
`;

export const RemainingBox = styled.span`
    display: inline-block;
    font-size: 0.8rem;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/timer/styles.js